const ChevronUp = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Icon/Collapse/24dp">
      <path
        id="Vector"
        d="M12.0008 8.4002C11.8674 8.4002 11.7424 8.42103 11.6258 8.4627C11.5091 8.50436 11.4008 8.5752 11.3008 8.6752L6.70078 13.2752C6.51745 13.4585 6.42578 13.6919 6.42578 13.9752C6.42578 14.2585 6.51745 14.4919 6.70078 14.6752C6.88411 14.8585 7.11745 14.9502 7.40078 14.9502C7.68411 14.9502 7.91745 14.8585 8.10078 14.6752L12.0008 10.7752L15.9008 14.6752C16.0841 14.8585 16.3174 14.9502 16.6008 14.9502C16.8841 14.9502 17.1174 14.8585 17.3008 14.6752C17.4841 14.4919 17.5758 14.2585 17.5758 13.9752C17.5758 13.6919 17.4841 13.4585 17.3008 13.2752L12.7008 8.6752C12.6008 8.5752 12.4924 8.50436 12.3758 8.4627C12.2591 8.42103 12.1341 8.4002 12.0008 8.4002Z"
        fill="#212121"
      />
    </g>
  </svg>
);

export default ChevronUp;
